export class fgStockTransferReq{
    transferType: string;
    Date:any;
    unitId:number;
}